import { parseCookies } from 'nookies';
import { CONSENT_COOKIE } from './constants';

type ConsentCookieCategory = {
    id: number;
    consentGiven?: boolean;
};

export const checkUserHasConsentedToPersonalisation = () => {
    const consentCookie = parseCookies()[CONSENT_COOKIE];

    if (typeof consentCookie !== 'string' || consentCookie === '') {
        return false;
    }

    try {
        const parsedCookie = JSON.parse(consentCookie);

        const allConsents = parsedCookie?.content?.consents || [];

        if (allConsents.length === 0) {
            return false;
        }

        const categories: ConsentCookieCategory[] =
            allConsents[0]?.categories || [];

        if (categories.length === 0) {
            return false;
        }

        return categories.some(
            (consentCategory) =>
                consentCategory?.id === 4 &&
                consentCategory?.consentGiven === true
        );
    } catch {
        return false;
    }
};
